import { render, staticRenderFns } from "./protocol-template.vue?vue&type=template&id=d973b272&scoped=true&"
import script from "./protocol-template.vue?vue&type=script&lang=js&"
export * from "./protocol-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d973b272",
  null
  
)

export default component.exports